// BASE_URL configuration
// Production API URL: https://smartagroai.lk/api
// Development API URL: http://localhost:8080/api

const getBaseUrl = () => {
  return 'https://digitalacademy.lk/api';

  //return "http://localhost:8090/api"; // Local development
};

const BASE_URL = getBaseUrl();

// Local image storage base URL (served by the backend)
//const IMAGE_BASE_URL = 'http://localhost:8080/api';

const IMAGE_BASE_URL = "http://localhost:8090/api"; // ✅ CORRECT

// Default placeholder images (served locally)
const DEFAULT_USER_PROFILE_IMAGE = `${IMAGE_BASE_URL}/uploads/user-images/avatar.png`;
const DEFAULT_COURSE_COVER_IMAGE = `${IMAGE_BASE_URL}/uploads/course-thumbnails/courceImg.jpeg`;

// Upload API endpoints
const UPLOAD_COURSE_THUMBNAIL_URL = `${BASE_URL}/upload/course-thumbnail`;
const UPLOAD_USER_IMAGE_URL = `${BASE_URL}/upload/user-image`;
const UPLOAD_BADGE_IMAGE_URL = `${BASE_URL}/upload/badge-image`;
const UPLOAD_CERTIFICATE_FILE_URL = `${BASE_URL}/upload/certificate-file`;

export {
  BASE_URL,
  IMAGE_BASE_URL,
  DEFAULT_USER_PROFILE_IMAGE,
  DEFAULT_COURSE_COVER_IMAGE,
  UPLOAD_COURSE_THUMBNAIL_URL,
  UPLOAD_USER_IMAGE_URL,
  UPLOAD_BADGE_IMAGE_URL,
  UPLOAD_CERTIFICATE_FILE_URL,
};
